// RetryMessage.jsx
// Message component explaining the retry situation

import React from 'react';
import { styles } from './styles';

const RetryMessage = () => {
  return (
    <p style={styles.message}>
      It looks like you need to complete your seller account setup. 
      Don't worry - you can continue where you left off.
    </p>
  );
};

export default RetryMessage;